var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-row",
        {
          staticStyle: {
            height: "calc(100% - 80px)",
            width: "calc(100% - 220px)",
            background: "white",
            position: "absolute",
          },
        },
        [
          _c(
            "router-link",
            { attrs: { to: { path: "/school/statistic/ArchiveSynthesizer" } } },
            [
              _c(
                "a-col",
                { staticStyle: { height: "100%" }, attrs: { span: 8 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-top": "150px",
                        height: "500px",
                        position: "relative",
                        top: "calc(50% - 250px)",
                        width: "calc(100% - 75px)",
                        left: "50px",
                        background: "#1783e8",
                        "border-radius": "16px",
                        "text-align": "center",
                        "line-height": "100px",
                        "font-size": "36px",
                        color: "white",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _c("div", [
                        _c("img", {
                          attrs: { src: require("@assets/school/icon1.png") },
                        }),
                      ]),
                      _c("div", [_vm._v("筛查")]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "router-link",
            { attrs: { to: { path: "/school/statistic/ArchiveSynthesizer" } } },
            [
              _c(
                "a-col",
                { staticStyle: { height: "100%" }, attrs: { span: 8 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-top": "150px",
                        height: "500px",
                        position: "relative",
                        top: "calc(50% - 250px)",
                        width: "calc(100% - 50px)",
                        left: "25px",
                        background: "#ffbd59",
                        "border-radius": "16px",
                        "text-align": "center",
                        "line-height": "100px",
                        "font-size": "36px",
                        color: "white",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _c("div", [
                        _c("img", {
                          attrs: { src: require("@assets/school/icon2.png") },
                        }),
                      ]),
                      _c("div", [_vm._v("评估")]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "router-link",
            { attrs: { to: { path: "/school/statistic/StudentMoodTrend" } } },
            [
              _c(
                "a-col",
                { staticStyle: { height: "100%" }, attrs: { span: 8 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-top": "150px",
                        height: "500px",
                        position: "relative",
                        top: "calc(50% - 250px)",
                        width: "calc(100% - 75px)",
                        left: "25px",
                        background: "#13b999",
                        "border-radius": "16px",
                        "text-align": "center",
                        "line-height": "100px",
                        "font-size": "36px",
                        color: "white",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _c("div", [
                        _c("img", {
                          attrs: { src: require("@assets/school/icon3.png") },
                        }),
                      ]),
                      _c("div", [_vm._v("干预")]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }